import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Menu } from '@material/mwc-menu';
import { StateController } from '../../helpers/state/state-management/state-controller';
import accountInfo from '../../helpers/state/account-info';
import featuresInfo from '../../helpers/state/features-info';
import { logWithAmplitude } from '../../helpers/api/api';

@customElement('folder-menu')
export class FolderMenu extends LitElement {
    static amplitude_callsite: string = 'Folder Menu';



    @query('#cornerMenu')
    cornerMenu!: Menu;

    @query('#menuConnect')
    menuConnect!: HTMLDivElement;

    @property({ type: Boolean })
    isOwner: boolean = false;

    @property({ type: Boolean })
    isWriter: boolean = false;

    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        this.cornerMenu.anchor = this.menuConnect;
    }

    private openMenu() {
        this.cornerMenu.open = true;
    }

    protected render() {
        if (!this.isOwner && !this.isWriter) return '';

        return html`
            <div style="position: relative">
                <div id="menuConnect" class="flexContainer">
                    <mwc-icon-button class="menuIcon" @click=${this.openMenu} icon="more_horiz">
                    </mwc-icon-button>
                </div>
                <mwc-menu id="cornerMenu" fixed x="0" y="30">
                    <mwc-list-item @click="${this.renameClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">drive_file_rename_outline</mwc-icon>
                            <span>Rename</span>
                        </div>
                    </mwc-list-item>
                    <mwc-list-item @click="${this.manageAccessClick}">
                        <div class="flexContainer">
                            ${featuresInfo.addFolderEditorsEnabled ? html`
                                <mwc-icon class="menuIcon">folder_shared</mwc-icon>
                            ` : html`
                                <img class="menuPng" src="/images/tiers/starter_small.png" />
                            `}
                            <span>Manage Access</span>
                        </div>
                    </mwc-list-item>
                    <mwc-list-item @click="${this.newSubFolderClick}">
                        <div class="flexContainer">
                            <mwc-icon class="menuIcon">subdirectory_arrow_right</mwc-icon>
                            <span>New Sub Folder</span>
                        </div>
                    </mwc-list-item>
                    ${this.isOwner
                        ? html`
                              <mwc-list-item @click="${this.deleteFolderClick}">
                                  <div class="flexContainer">
                                      <mwc-icon class="menuIcon">delete</mwc-icon>
                                      <span>Delete Folder</span>
                                  </div>
                              </mwc-list-item>
                          `
                        : ''}
                </mwc-menu>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --mdc-menu-min-width: min(100vw, 232px);
                --mdc-typography-subtitle1-font-size: 12px;
                --context-menu-color: var(--theme-input-color);
                --mdc-icon-button-size: 1.5rem;
            }

            .menuIcon {
                color: var(--context-menu-color);
                cursor: pointer;
                --mdc-icon-size: 16px;
            }

            .menuPng {
                margin-right: 0.25rem;
                height: 20px;
                margin-top: auto;
                color: var(--context-menu-color);
                cursor: pointer;
            }

            mwc-list-item {
                --mdc-menu-item-height: 2.5rem;
                color: var(--context-menu-color);
            }

            mwc-list-item:hover {
                --context-menu-color: var(--main-primary-color);
                font-weight: 500;
            }

            .flexContainer {
                display: flex;
                align-items: center;
            }

            @media only screen and (max-width: 550px) {
                .menuPng {
                    margin-top: 20px;
                }
            }
        `;
    }

    private renameClick() {
        logWithAmplitude(FolderMenu.amplitude_callsite, 'Folder Rename Click');
        this.dispatchEvent(
            new CustomEvent('rename-folder', {
                detail: {
                    type: 'rename-folder',
                },
            })
        );
    }

    private manageAccessClick() {
        logWithAmplitude(FolderMenu.amplitude_callsite, 'Folder Manage Access Click');
        this.dispatchEvent(
            new CustomEvent('manage-folder-access', {
                detail: {
                    type: 'manage-folder-access',
                },
            })
        );
    }

    private newSubFolderClick() {
        logWithAmplitude(FolderMenu.amplitude_callsite, 'Folder New Subfolder Click');
        this.dispatchEvent(
            new CustomEvent('add-sub-folder', {
                detail: {
                    type: 'add-sub-folder',
                },
            })
        );
    }

    private deleteFolderClick() {
        logWithAmplitude(FolderMenu.amplitude_callsite, 'Folder Delete Click');
        this.dispatchEvent(
            new CustomEvent('delete-folder', {
                detail: {
                    type: 'delete-folder',
                },
            })
        );
    }
}
